/* eventos para monstar y ocular el menu despegable */
export function handleMouseIn() {
  const menuDespegable = document.querySelector('.menu-despegable');
  menuDespegable?.classList?.add('show');
}
export function handleMouseOut() {
  const menuDespegable = document.querySelector('.menu-despegable');
  menuDespegable?.classList?.remove('show');
}

export function handleOpenMenu() {
  const menu = document.querySelector('#mobile-menu');
  menu?.classList?.add('active');
}

export function handelCloseMenu() {
  const menu = document.querySelector('#mobile-menu');
  menu?.classList?.remove('active');
}
